import { AutogenLayoutOfficeEmployeeAnniversaryBirthdayReport } from "./autogen/AutogenLayoutOfficeEmployeeAnniversaryBirthdayReport";
import { DataSourceValidationEvent, ValidationResult } from "@mcleod/components";

export class OfficeEmployeeAnniversaryBirthdayReport extends AutogenLayoutOfficeEmployeeAnniversaryBirthdayReport {
    override onLoad(): void {
        super.onLoad();
        // Default selections: Report Type = Anniversary and Birthday (index 2), Group By = None (index 0)
        if (this.textboxReportType.items && this.textboxReportType.items.length >= 3) {
            this.textboxReportType.selectedItem = this.textboxReportType.items[2];
        }
        if (this.textboxGroupBy.items && this.textboxGroupBy.items.length >= 1) {
            this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        }
    }

    officeEmployeeAnniversaryBirthdayDatasourceOnValidate(event: DataSourceValidationEvent) {
        const result = this.validateDate();
        if (result) {
            event.validationResults.push(result);
        }
    }

    public validateDate(): ValidationResult {
        const dateRange = this.textboxDateRange.getDateRange();
        //checks that the date range is not more than 1 year
        const oneYearInMillis = 365 * 24 * 60 * 60 * 1000;
        if(dateRange.endDate.getTime() - dateRange.startDate.getTime() > oneYearInMillis) {
            const message = "Date ranges are limited to one year to prevent any employee from appearing more than once on the report.";
            return {
                isValid: false,
                validationMessage: message,
                caption: message,
                component: this.textboxDateRange
            };
        }
    }

    textboxGroupByOnChange() {
        if(this.textboxGroupBy.selectedItem.value === "N") {
            this.checkboxPageBreakAfterGroupBy.enabled = false;
            this.checkboxPageBreakAfterGroupBy.checked = false;
        } else {
            this.checkboxPageBreakAfterGroupBy.enabled = true;
        }
    }


}
